<template>
  <div class="comp-container" :class="bgType == 2 ? 'bg-type2' : ''">
    <div></div>
    <div
      class="item"
      :class="selected == item.key ? 'active' : ''"
      @click="select(item)"
      v-for="(item, index) in itemList"
      :key="index"
    >
      <div class="text">
        <AutoTitle textAlign="center" :title="item.name" />
      </div>
      <!-- {{item.name}} -->
    </div>
    <div></div>
  </div>
</template>

<script>
import { axios, webSocket } from "../../../../common";
import AutoTitle from "../../../../components/autoTitle";
import { mapState, mapGetters } from "vuex";

export default {
  name: "titleSwitch",
  props: {
    itemList: {},
    value: {},
    bgType: {},
  },
  data() {
    return {
      // selected:'1',
      // itemList:[{
      //   name:'1',
      //   key:'1',
      // },{
      //   name:'2',
      //   key:'2',
      // },{
      //   name:'3',
      //   key:'3',
      // },{
      //   name:'4',
      //   key:'4',
      // },]
    };
  },
  computed: {
    // ...mapState(['userData']),
    selected() {
      return this.value;
    },
  },
  watch: {},
  methods: {
    select(item) {
      // this.selected = item.key;
      this.$emit("input", item.key);
    },
  },
  components: {
    AutoTitle,
  },
  mounted() {},
  created() {},
};
</script>

  <style lang="scss" scoped>
.comp-container {
  $height: 0.43rem;
  margin: 0.2rem 0;
  height: $height;
  width: $height * (9.36/0.43);
  max-width: 100%;
  background-image: url(./imgs/bg.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 0.2rem;
  &.bg-type2 {
    background-image: url(./imgs/bg-type2.png);
  }
  .item {
    $width: 1.38rem;
    height: $height;
    min-width: $width;
    margin: 0 0.2rem;
    text-align: center;
    font-size: 0.2rem;
    line-height: $height;
    color: #fff;

    &.active {
      font-weight: 600;

      position: relative;
      .text {
        // 因为用了AutoTitle组件，所以需要这样设置
        /deep/ span.title {
          background-image: -webkit-linear-gradient(top, #ffd266, #ffe7a8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        background: url(./imgs/selected.png) no-repeat;
        background-size: $width auto;
        background-position: bottom;
      }

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: linear-gradient(
          bottom,
          rgba(#ffd737, 0.7),
          rgba(#ffd737, 0) 0.6
        );
        animation: flash 1.5s infinite linear;
      }
      @-webkit-keyframes flash {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
  }
}
</style>
